module.exports = __webpack_public_path__ + "img/cookie-emoji.2a09ec1e.png";